/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.photo.ts
 *
 * Messages de « Ma photo » (compte d'administration, /admin/self-photo)
 * et du lien « Mon profil et ma photo » de l'espace exposant.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-09-20
 */
export const messagesPhotoFr: Record<string, string> = {
  'adminNav.selfPhoto': 'Ma photo',
  'acces.titre.adminPhoto': 'Ma photo',

  'selfPhoto.titre': 'Ma photo de profil',
  'selfPhoto.sousTitre':
    'Elle apparaît sur votre fiche complète. Une image JPEG ou PNG, 5 Mo au plus ; vous la cadrez dans le rond avant l’envoi.',
  'selfPhoto.alt': 'Votre photo de profil',
  'selfPhoto.deposer': 'Déposer une photo',
  'selfPhoto.remplacer': 'Remplacer la photo',
  'selfPhoto.depotAria': 'Choisir une photo de profil',
  'selfPhoto.aide': 'JPEG ou PNG, 5 Mo maximum, 64 px de côté au minimum.',
  'selfPhoto.supprimer': 'Supprimer la photo',
  'selfPhoto.confirmerSuppression': 'Supprimer votre photo de profil ?',
  'selfPhoto.envoi': 'Envoi en cours…',
  'selfPhoto.enregistree': 'Photo enregistrée.',
  'selfPhoto.supprimee': 'Photo supprimée.',
  'selfPhoto.erreur.tropLourde': 'Image trop lourde : 5 Mo au maximum.',
  'selfPhoto.erreur.format': 'Format non accepté : envoyez une image JPEG ou PNG d’au moins 64 px de côté.',
  'selfPhoto.erreur.depot': 'Impossible d’enregistrer la photo. Réessayez.',
  'selfPhoto.erreur.suppression': 'Impossible de supprimer la photo. Réessayez.',

  'monStand.monProfil': 'Mon profil et ma photo',
};
